import React, { useEffect, useState } from 'react'
import {
    Layout, Row, Col, Typography, Button, Card, Spin, Form, Select, Upload, DatePicker, message, notification, Divider, Tag,
    Input,
} from 'antd';
// import Header from '../../component/header/header';
import { Header } from '../../component/header/header';
import { UploadOutlined, CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import Sidebar from '../../component/siderbar/sidebar';
import { createEvent, uploadImage } from '../../features/getEvents/getEvents';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { uploadImageApi } from '../../apiinteraction/apiinteraction';
import moment from 'moment';
import Papa from 'papaparse';
import filePath from '../../csvFile/combined.csv';
import './manualEntry.css';


function ManualEntry() {

    const validateMessage = (data) => {
        const args = {
            message: 'Error',
            description:
                `${data?.message}`,
            duration: 5,
        };
        notification.error(args);
    };

    const [form] = Form.useForm()

    const { Footer, Sider, Content } = Layout;

    const { Title } = Typography;

    const { Option } = Select;

    const { RangePicker } = DatePicker;

    const dispatch = useDispatch();

    const history = useHistory();

    const [region, setRegion] = useState('');

    const [flag, setFlag] = useState('')

    const [timestamp, setTimestamp] = useState(Date())

    const [resURL, setResURL] = useState("")

    const [loader, setLoader] = useState(false)

    const [filelist, setFilelist] = useState(null)

    const [startTime, setStartTime] = useState(null);
    const [binaryImage, setBinaryImage] = useState(null);

    const [csvdata, setCsvData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [uniqueCameraNames, setUniqueCameraNames] = useState([]);
    const [kpiType, setKpiType] = useState(null);

    const handleKpiTypeChange = (value) => {
        setKpiType(value);
    };


    useEffect(() => {
        fetch(filePath)
            .then(response => response.text())
            .then(csvString => {
                Papa.parse(csvString, {
                    header: true,
                    dynamicTyping: true,
                    complete: (result) => {
                        const parsedData = result.data.map(row => {
                            const filledRow = {};
                            result.meta.fields.forEach(field => {
                                filledRow[field] = row[field] !== undefined ? row[field] : null;
                            });
                            return filledRow;
                        });
                        setCsvData(parsedData);
                        setAllData(parsedData);
                        extractUniqueCameraNames(parsedData);

                    },
                });
            })
            .catch(error => console.error('Error fetching the CSV file:', error));
    }, [filePath]);

    const extractUniqueCameraNames = (data) => {
        const cameraNames = data.map(item => item.cameraName);
        const uniqueNames = [...new Set(cameraNames)];
        setUniqueCameraNames(uniqueNames);
    };

    let filePasted = []
    const onFinish = async (values) => {

        const formData = new FormData();
        console.log({ values })
        formData.append('image', values?.uploadImage);
        formData.append('hasWpn', values?.hasWpn || "False");
        formData.append('cameraName', values?.cameraName);
        formData.append('detectionName', values?.detectionName);
        formData.append('kpiType', values?.kpiType);
        formData.append('startTime', moment(values?.startTime.toISOString()).format('DD-MM-YYYY HH:mm:ss'));
        formData.append('endTime', moment(values?.endTime.toISOString()).format('DD-MM-YYYY HH:mm:ss'));

        try {
            setLoader(true);
            let result = await dispatch(createEvent(formData));
            if (result.payload.success == true) {
                history.push('./dashboard');
            } else {
                validateMessage(result.payload.data);
            }
            setLoader(false);
        } catch (err) {
            console.log(err);
            setLoader(true);
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        console.log(resURL)
    };


    function handleChangeLocation(value) {
        setRegion(value)
        console.log(value)
    }


    function handleChangeFlag(value) {
        setFlag(value)
        console.log(value)
    }



    function onChangeDate(value, dateString) {
        // console.log('Selected Time: ', value);
        // console.log('Formatted Selected Time: ', dateString);
        setTimestamp(value)
    }

    function onOk(value) {
        // console.log('onOk: ', value);
        setTimestamp(value)
    }

    const imageTypes = ['png', 'PNG', 'jpg', 'JPG', 'JPEG', 'jpeg']

    const [errorFlag, setErrorFlag] = useState(false)
    console.log(filelist);


    const handleUpload = async options => {

        setErrorFlag(false)
        setLoader(true)


        let { onSuccess, onError, file, onProgress } = options;
        let fileType = file.type.split('/')
        if (!imageTypes.includes(fileType[1])) {
            setLoader(false)
            validateMessage({ message: "Only Images are allowed!" })
            return
        }

        // const isLt2M = file.size / 1024 / 1024 < 2;

        try {
            console.log(file);

            let result = await uploadImageApi(file)
            console.log({ result }, 'new result');
            message.success('Image submitted successfully');
            setErrorFlag(true)
            // setResURL(result.message)

            form.setFieldsValue({
                uploadImage: file,
            })

        } catch (err) {
            // console.log("Eroor: ", err);
            message.error('Error uploading image');

        }

        setLoader(false)
    };

    const handleCopyPasteImage = async (file) => {

        setErrorFlag(false)
        setLoader(true)


        let fileType = file.type.split('/')
        if (!imageTypes.includes(fileType[1])) {
            setLoader(false)
            validateMessage({ message: "Only Images are allowed!" })
            return
        }


        try {
            console.log(file);

            let result = await uploadImageApi(file)
            console.log({ result });
            message.success('Image submitted successfully');
            setErrorFlag(true)
            form.setFieldsValue({
                uploadImage: result.message
            })

        } catch (err) {
            message.error('Error uploading image');

        }

        setLoader(false)
    };

    const handleDelete = () => {
        form.setFieldsValue({
            uploadImage: null
        })
        setErrorFlag(false)
        setResURL('')
    }


    useEffect(() => {
        const handlePaste = (event) => {
            const items = event.clipboardData.items;
            console.log(items)
            if (items?.length > 1) return message.error("Bulk image upload not allowed")
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.kind === 'file') {
                    const file = item.getAsFile();
                    // Upload the file here using your upload logic
                    // setFilelist(file)
                    console.log(i + 'Pasting file:', file);
                    handleCopyPasteImage(file)
                    // You can use your custom logic to upload the file, e.g., via the Ant Design Upload component or a separate API call.
                }
            }
        };

        // Add the paste event listener
        document.addEventListener('paste', handlePaste);

        // Remove the event listener when the component unmounts
        return () => {
            document.removeEventListener('paste', handlePaste);
        };
    }, []);



 const disabledEndDate = (current) => {
        if (!startTime) {
            return current && current > moment().endOf('day'); // Disable future dates
        }
        return current && (current > moment().endOf('day') || current < startTime.startOf('day'));
    };

    return (
        <div>

            <Layout>
                <Header />

                <Layout>

                    <Sidebar currentKey={"2"} />

                    <Content>

                        <Spin spinning={loader}>
                            <div className='manual-entry-page'>
                                <div className='manual-entry-page-head'>
                                    <div>
                                        <Title level={2} className='manual-entry-heading'>Manual Entry</Title>
                                        <div className='manual-entry-subheading'>
                                            Log a detection event that wasn't captured automatically
                                        </div>
                                    </div>
                                </div>

                                <Card className='manual-entry-card'>
                                    <div className='manual-entry-section-title'>Event Details</div>
                                    <div className='manual-entry-section-sub'>
                                        All fields marked required must be completed before submitting
                                    </div>
                                    <Form
                                        name="basic"
                                        labelCol={{ span: 24 }}
                                        wrapperCol={{ span: 24 }}
                                        initialValues={{ remember: false }}
                                        onFinish={onFinish}
                                        onFinishFailed={onFinishFailed}
                                        autoComplete="off"
                                        className='manual-entry-form'
                                        form={form}
                                    >
                                        <Form.Item
                                            label="Camera Name"
                                            name="cameraName"
                                        >
                                            <Select className='w-100' placeholder="Select Camera Name">
                                                {uniqueCameraNames.map((name, index) => (
                                                    <Option key={index} value={name}>{name}</Option>
                                                ))}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item
                                            label="Detection Name"
                                            name="detectionName"
                                        >
                                            <Input className='w-100' placeholder="Detection Name" />
                                        </Form.Item>

                                        <Form.Item
                                            label="Detection Type"
                                            name="kpiType"
                                            rules={[{ required: true, message: 'Please select KPI!' }]}
                                        >
                                            <Select className='w-100' placeholder="Select Detection Type" onChange={handleKpiTypeChange}>
                                                <Option value="Baggage Detection">Baggage Detection</Option>
                                                <Option value="Number Plate">Number Plate</Option>
                                                <Option value="Face Recognition">Face Recognition</Option>
                                                <Option value="FireSmoke Detection">Fire &amp; Smoke Detection</Option>
                                                <Option value="PPE Detection">PPE Detection</Option>
                                                <Option value="ForeignMaterial Detection">Foreign Material Detection</Option>
                                            </Select>
                                        </Form.Item>

                                        {kpiType === 'Baggage Detection' && (
                                            <Form.Item
                                                label="Has Baggage"
                                                name="hasWpn"
                                                rules={[{ required: true, message: 'Please select Has Baggage!' }]}
                                            >
                                                <Select className='w-100' placeholder="Select Yes or No">
                                                    <Option value="True">True</Option>
                                                    <Option value="False">False</Option>
                                                </Select>
                                            </Form.Item>
                                        )}

                                        <Row gutter={16}>
                                            <Col xs={24} sm={12}>
                                                <Form.Item
                                                    label="Start Time"
                                                    name="startTime"
                                                    rules={[{ required: true, message: 'Please select Start Time!' }]}
                                                >
                                                    <DatePicker
                                                        disabledDate={(current) => {
                                                            return current && current > moment(new Date(), "DD-MM-YYYY");
                                                        }}
                                                        className='w-100'
                                                        showTime
                                                        format="DD-MM-YYYY HH:mm:ss"
                                                        placeholder="Start Time"
                                                        onChange={(value) => setStartTime(value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={12}>
                                                <Form.Item
                                                    label="End Time"
                                                    name="endTime"
                                                    rules={[
                                                        { required: true, message: 'Please select End Time!' },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value || getFieldValue('startTime') && value.isSameOrBefore(getFieldValue('startTime'))) {
                                                                    return Promise.reject('End time must be after start time!');
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <DatePicker
                                                        disabledDate={disabledEndDate}
                                                        className='w-100'
                                                        showTime
                                                        format="DD-MM-YYYY HH:mm:ss"
                                                        placeholder="End Time"
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Form.Item
                                            label="Upload Image"
                                            name="uploadImage"
                                            rules={[{ required: true, message: 'Please Insert Image!' }]}
                                        >
                                            <Upload
                                                customRequest={handleUpload}
                                                onProgress={false}
                                                className='upload-image-icon-custom'
                                                showUploadList={false}
                                            >
                                                {!errorFlag &&
                                                    <div className='manual-entry-upload-row'>
                                                        <Button className='manual-entry-upload-btn' icon={<UploadOutlined />}>Upload</Button>
                                                        <span className='manual-entry-upload-hint'>drag &amp; drop or paste image</span>
                                                    </div>
                                                }
                                            </Upload>
                                            {errorFlag &&
                                                <div className='manual-entry-upload-row'>
                                                    <div className='manual-entry-uploaded'>
                                                        <CheckOutlined />
                                                        Uploaded
                                                    </div>
                                                    <Button
                                                        className='manual-entry-upload-btn'
                                                        onClick={handleDelete}
                                                        icon={<DeleteOutlined />}
                                                    >
                                                        Delete
                                                    </Button>
                                                </div>}
                                        </Form.Item>

                                        <Form.Item wrapperCol={{ span: 24 }} style={{ marginBottom: 0, marginTop: 8 }}>
                                            <Button className='manual-entry-submit' type="primary" htmlType="submit">
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </div>
                        </Spin>

                    </Content>

                </Layout>
            </Layout>

        </div >
    )
}

export default ManualEntry
